var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [(!_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Get Started',
          icon: 'ni ni-spaceship  text-green',
          path: '/onboarding-redirect'
        }}}):_vm._e(),(_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'ni ni-shop text-red',
          path: '/ec_dashboard'
        }}}):_vm._e(),(_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Key Documents', 
          icon: 'ni ni-folder-17 text-default',
          path: '/key_documents'
        }}}):_vm._e(),(_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Documents',
          icon: 'fa fa-mail-bulk text-default',
          path: '/documents'
        }}}):_vm._e(),(_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Officers',
          icon: 'fa fa-user-tie text-blue',
          path: '/officers'
        }}}):_vm._e(),(_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Shareholders',
          icon: 'fa fa-users text-green',
          path: '/shareholders'
        }}}):_vm._e(),(_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Timeline',
          icon: 'fa fa-hourglass-half text-warning',
          path: '/timeline'
        }}}):_vm._e(),(_vm.hasEntity)?_c('sidebar-item',{attrs:{"link":{
          name: 'Requests',
          icon: 'fa fa-pencil-alt text-default',
          path: '/requests'
        }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Create Request', path: '/create-request' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'View Requests', path: '/requests' }}})],1):_vm._e()]}}])}),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }